'use strict';

module.exports = require('./Switch');


//////////////////
// WEBPACK FOOTER
// ./~/_rc-switch@1.5.1@rc-switch/lib/index.js
// module id = 644
// module chunks = 0 1